import React from 'react';
import {useSelector} from 'react-redux';
import {selectMissionActiveReplica} from '../../../redux/reducers/privateStateReducer/selectors';
import {REPLICA_SIDES} from '../../../configs/campaigns/missionFormat';
import './MissionReplica.css';

/**
 * Персонаж говорящей реплики — картинка над футером, слева или справа (см.
 * replica.side). Слой намеренно ниже панели редактора миссий по z-index:
 * автор должен видеть свою панель поверх персонажа.
 */
const MissionReplicaCharacter = () => {
  const replica = useSelector(selectMissionActiveReplica);

  if (!replica?.characterImage) {
    return null;
  }

  const side = replica.side === REPLICA_SIDES.RIGHT ? REPLICA_SIDES.RIGHT : REPLICA_SIDES.LEFT;

  return (
    <div className={`mission-replica-character mission-replica-character_${side}`}>
      <img
        className={'mission-replica-character_image'}
        src={replica.characterImage}
        alt={replica.characterName || 'Персонаж'}
      />
    </div>
  );
};

export default MissionReplicaCharacter;
